import { ReactNode, useState, useContext } from "react";

import { Stack, Typography, Box, TextField, InputAdornment } from "@mui/material";

import { SettingsOptionsContext } from "../SettingsOptions";

interface SettingsTextFieldProps {
  /**
   * Acts as the identifier of the settings option.
   */
  keyid: string;
  /**
   * Label to be displayed in the UI
   */
  label: string;
  /**
   * Optional - Allows component to act as either controlled or uncontrolled
   */
  value?: string | undefined;
  /**
   * Optional - If "value" prop is null, this is next in line as the inital state value.
   */
  defaultValue?: string;
  /**
   * Optional - Lets users set horizontal alignment
   */
  inputAdornment?: string | ReactNode;
  /**
   * Left or Right on the inside of the text field
   */
  adornmentPlacement?: string;
}

export default function SettingsTextField(props: SettingsTextFieldProps) {
  const settignsOptions = useContext(SettingsOptionsContext);
  const [value, setValue] = useState<string | undefined>(props.value ?? props.defaultValue);

  const inputProps = props.inputAdornment
    ? {
        [`${props.adornmentPlacement}`]: props.inputAdornment
        ? <InputAdornment position="start">{props.inputAdornment}</InputAdornment>
        : <></>
      }
    : {};
  
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        width: "100%"
      }}>
      <Typography sx={{ flex: 1 }}>{props.label}</Typography>
      <Box sx={{ flex: 2 }}>
        <TextField
          autoComplete="off"
          sx={{ width: "100%" }}
          value={value}
          slotProps={{ input: inputProps }}
          onChange={e => {
            settignsOptions?.updateSettingsState(props.keyid, e.target.value);
            setValue(e.target.value);
          }}
        />
      </Box>
    </Stack>
  );
}